import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';
import {
  apiChat,
  apiCase,
  apiSMSChat,
  apiCrm,
  apiInstagramChat
} from '../../../http';

class ChatBroadcastListService extends ServiceCRUD {
  constructor() {
    super('/broadcast-list');
  }

  getContactsFromBroadcastList(broadcastListId, queryParams) {
    return apiChat.get(`/broadcast-list/${broadcastListId}/contacts`, {
      params: queryParams
    });
  }

  getAllContactsFromBroadcastList(broadcastListId, queryParams) {
    return apiChat.get(`/broadcast-list/contacts`, {
      params: queryParams
    });
  }

  updateBroadcastWithMidia(data, id) {
    return apiChat.put(`broadcast-list/midia/${id}`, data, {
      headers: { 'content-type': 'multipart/form-data' }
    });
  }

  createBroadcastWithMidia(data) {
    return apiChat.post('broadcast-list/midia', data, {
      headers: { 'content-type': 'multipart/form-data' }
    });
  }

  getContacts(queryParams) {
    return apiChat.get(`/broadcast-list/contacts`, {
      params: queryParams
    });
  }

  addContactsToBroadcastList(broadcastListId, clients) {
    return apiChat.post('/broadcast-list/contacts', {
      broadcastListId,
      clients
    });
  }

  getAllWithoutPagination(showDisabledTransmissionLists) {
    return apiSMSChat.get(
      `/broadcast-list/all?showDisabled=${showDisabledTransmissionLists}`
    );
  }

  removeContactsFromBroadcastList(broadcastListId, clientIds = []) {
    return apiChat.put('/broadcast-list/contacts', {
      broadcastListId,
      clientIds
    });
  }

  executeBroadcastList(data) {
    return apiChat.post('/broadcast-list/execute', data);
  }

  resumeBroadcastList(data) {
    return apiChat.post(`/broadcast-list/resume/${data.broadcastListId}`);
  }

  pauseBroadcastList(data) {
    return apiChat.post(`/broadcast-list/pause/${data.broadcastListId}`);
  }

  syncBroadcastList(id) {
    return apiChat.get(`/broadcast-list/synchronize/${id}`);
  }

  importList(entityName, data, broadcastListId) {
    return apiCase.post(
      `/entity/${entityName}/import/broadcast-list/${broadcastListId}`,
      data
    );
  }

  changeBroadcastListStatus(id) {
    return apiChat.put(`/broadcast-list/change-status/${id}`);
  }

  getAllSearch(page, size, title, showDisable = false) {
    return apiChat.get(`${this.path}?showDisabled=${showDisable}`, {
      headers: {
        limit: size,
        offset: size * (page - 1)
      },
      params: {
        title: title
      }
    });
  }

  async getRecordTypesProtocol() {
    const response = await apiCase.get(`/record-type`);
    return response?.data?.recordTypes?.flatMap((recordType) => {
      if (recordType?.entity === 'PROTOCOL') {
        return [
          {
            value: recordType.id,
            label: recordType.name
          }
        ];
      }
      return [];
    });
  }

  async getProtocolFieldsDefaultByRecordType(recordTypeId) {
    const response = await apiCase.get(
      `/protocol/fields/default-fields-display-config/${recordTypeId}`
    );
    return response?.data?.content?.defaultFieldsConfig;
  }

  async getProtocoloCustomFieldsByRecordType(recordTypeId) {
    const response = await apiCrm.get(`/custom-field/PROTOCOL/${recordTypeId}`);
    return response?.data.data;
  }
  async getReasons(recordTypeId) {
    const response = await apiCase.get(
      `/reasons/by-record-type/${recordTypeId}`
    );
    return response?.data.content;
  }

  async getSubReasons(reasonId) {
    const response = await apiCase.get(`/subreasons/by_reason/${reasonId}`);
    return response?.data.content.map((subReason) => ({
      label: subReason.name,
      value: subReason.id
    }));
  }

  async getStatus(recordTypeId) {
    const response = await apiCase.get(
      `/status/by-record-type/${recordTypeId}`
    );
    return response?.data?.content.map((status) => ({
      label: status.name,
      value: status.id
    }));
  }

  async getType(broadcastListId) {
    const response = await apiInstagramChat.get(
      `/broadcast-list/${broadcastListId}/type`
    );
    return response?.data;
  }

  async getImportFields(idBroadcastList) {
    const response = await apiInstagramChat.get(
      `/broadcast-list/${idBroadcastList}/import-fields`
    );
    return response?.data;
  }
}

export default new ChatBroadcastListService();
